module.exports = __webpack_public_path__ + "static/media/voice-icon.58b577ee.svg";